module.exports = __webpack_public_path__ + "../public/img/ylw_icoQr.d64aa04d.png";